import type { WorkItemStatus } from './workflow'

// The work item status state machine. This mirrors the rules currently enforced
// by the mirage stub server and is the single source of truth a real backend
// adapter should defer to. Terminal states allow no further transitions.
const ALLOWED_STATUS_TRANSITIONS: Record<WorkItemStatus, WorkItemStatus[]> = {
	inbox: ['open', 'awaiting_handoff', 'cancelled', 'archived'],
	open: ['awaiting_handoff', 'completed', 'cancelled', 'archived'],
	awaiting_handoff: ['inbox', 'open', 'completed', 'cancelled', 'archived'],
	completed: ['archived'],
	cancelled: ['archived'],
	archived: [],
}

const TERMINAL_STATUSES: WorkItemStatus[] = ['completed', 'cancelled', 'archived']

const isTerminalStatus = (status: WorkItemStatus): boolean => TERMINAL_STATUSES.includes(status)

const canTransitionStatus = (from: WorkItemStatus, to: WorkItemStatus): boolean =>
	ALLOWED_STATUS_TRANSITIONS[from].includes(to)

const assertStatusTransition = (from: WorkItemStatus, to: WorkItemStatus): void => {
	if (!canTransitionStatus(from, to)) {
		throw new Error(`Invalid work item status transition: ${from} -> ${to}`)
	}
}

export { ALLOWED_STATUS_TRANSITIONS, TERMINAL_STATUSES, isTerminalStatus, canTransitionStatus, assertStatusTransition }
